import moment from 'moment'
import React, { useEffect } from 'react'
import { Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as Routes from './models/routes.model'
import { animateScroll as scroll } from 'react-scroll'
// import Footer from './components/UI/footer/pageFooter'
import NoMatch from './view/noMatch'
// import PreviewReport from './view/creport/preview'
import { getToken, setCacheURL } from './utils/storage'
import { getClientType } from './utils/common'
import { publicPath, noCheckPath, CharacterLevel } from './utils/constant'
import './App.sass'
import usePermissions from './hooks/usePermissions'
import Route from './components/CustomRoute'
import PageLoading from './components/UI/status/loading'
import _ from 'lodash'

moment.locale('en', {
  week: {
    dow: 1
  }
})

const isDeeplink = (hash) => {
  const client = getClientType()
  if (client === 'app') {
    const deeplink = process.env.REACT_APP_IOS_DEEPLINk
    window.location.href = deeplink + hash
  }
}

const href = window.location.href
if (href.match('/password-reset/') && !href.match('/password-reset/verify')) {
  isDeeplink(href.split('/password-reset/')[1])
}

const isPublic = (pathname) => {
  return publicPath.find((path) => {
    const match = pathname.match(path)
    return match && match.index === 0
  })
}
const isNoCheck = (pathname) => {
  return noCheckPath.find((path) => {
    const match = pathname.match(path)
    return match && match.index === 0
  })
}

function App(props) {
  const {
    location: { pathname },
    history,
    account: { user }
  } = props

  const { loaded } = usePermissions()

  useEffect(() => {
    const initial = () => {
      const location = history.location
      const token = getToken()
      const isPublicLink = isPublic(location.pathname)
      const isNoCheckLink = isNoCheck(location.pathname)

      if (!token || !user) {
        if (!isPublicLink) {
          if (location.pathname !== '/') {
            setCacheURL(`${location.pathname}${location.search}`)
          }
          history.push('/sign-in')
        }
      } else if (user && !(isPublicLink || isNoCheckLink)) {
        // const {
        //   profile: { membership_selected }
        // } = user
        const onboarding_required = _.get(
          user,
          'profile.onboarding_steps.onboarding_required',
          false
        )
        if (
          location.pathname === '/app/setting/view-signed-forms' &&
          onboarding_required
        ) {
          history.push('/redirect-sign-waiver-form')
        } else if (
          user.person_character === CharacterLevel.client &&
          location.pathname !== '/2fa'
        ) {
          // if (!membership_selected) {
          //   history.push('/membership-selection')
          // } else if (onboarding_required !== false) {
          //   history.push('/onboarding/ready')
          // }
          if (onboarding_required !== false) {
            history.push('/onboarding/ready')
          }
        }
      }
    }

    initial()
  }, [])

  useEffect(() => {
    scroll.scrollToTop({ ignoreCancelEvents: true })
  }, [pathname])

  return (
    <div className="App">
      <div>
        {loaded ? (
          <Switch>
            {/* <Route path="/creport/preview/:hash" component={PreviewReport} /> */}
            {dynamicRoutes(user && user.person_character).map(
              (route, index) => (
                <Route
                  perm={route.perm}
                  exact={route.exact}
                  path={route.path}
                  component={route.component}
                  render={route.render}
                  key={index}
                />
              )
            )}
            {user && <Route component={NoMatch} />}
          </Switch>
        ) : (
          <PageLoading />
        )}
        {/* <Footer {...props} /> */}
      </div>
    </div>
  )

  function dynamicRoutes(character) {
    if (!character) return Routes.commonRoutes
    let routes = Routes.commonRoutes
    switch (character) {
      case CharacterLevel.super_admin:
      case CharacterLevel.admin:
      case CharacterLevel.expert:
        routes = routes.concat(Routes.coachRoutes)
        break
      case CharacterLevel.service_provider:
        routes = routes.concat(Routes.providerRoutes)
        break
      case CharacterLevel.client:
        routes = routes.concat(Routes.clientRoutes)
        break
      default:
        break
    }
    return routes
  }
}

export default withRouter(connect(({ account }) => ({ account }), null)(App))
